import React from "react";
import LoaderGif from "../../assest/loader.gif";
const Loader = () => {
  return (
    <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center backdrop-blur-sm bg-[#ffffff96] z-[9999]">
      <img src={LoaderGif} alt="" className="w-1/12 max-[740px]:w-3/12" />
    </div>
  );
};

export default Loader;
